<template>
  <AccessHandler
    :requiredRoleGroups="roleGroups"
    @accessChanged="(a: boolean) => (hasAccess = a)"
  />
  <div class="schedule-b-page" data-cy="schedule-b-page">
    <MasterPage>
      <template v-if="!isMobile() && hasAccess" v-slot:content>
        <header class="page__header--container clearfix">
          <h1 class="page__title--text pull-left">
            PRODUCT LISTING <small>Schedule B</small>
          </h1>
        </header>
        <div class="schedule-b-container">
          <ScheduleBView />
        </div>
        <GlobalFooter />
      </template>
      <template v-else-if="hasAccess" v-slot:content>
        <div class="sched-panel-title">
          <span class="schedule-title" data-cy="ukd-products-page-title"
            >Product Listing <small>Schedule B</small></span
          >
        </div>
        <ScheduleBMobileView />
        <GlobalFooter />
      </template>
    </MasterPage>
  </div>
</template>

<script setup lang="ts">
import MasterPage from "../MasterPage.vue";
import { useMainStore } from "@/stores/useMainStore";
import GlobalFooter from "../GlobalFooter.vue";
import ScheduleBView from "./ScheduleBView.vue";
import ScheduleBMobileView from "./ScheduleBMobileView.vue";
import {
  ScheduleAppGroup,
  ProductAppGroup,
  type RoleGroup,
} from "@/shared/access/RoleGroups";
import { ref } from "vue";
import AccessHandler from "@/shared/access/AccessHandler.vue";
import { isMobile } from "../../shared/helpers/mobileHelper";

const main = useMainStore();

const roleGroups = [
  {
    roles: [...ScheduleAppGroup.roles, ...ProductAppGroup.roles],
  },
  {
    roles: [],
    validateRestrictionsAsync: async () => {
      return (
          main.companySummary?.denials.every(
          (d) => !d.SchedB || d.SchedB.toUpperCase() !== "ALL"
        )
      );
    },
  },
] as RoleGroup[];

const hasAccess = ref<boolean>(false);
</script>

<style scoped lang="scss">
.schedule-b-container {
  margin: 10px 30px 30px;
  padding: 0;
  width: auto;
}

.sched-panel-title {
  padding: 5px 15px;
  display: flex;
  font-size: 11px;
  background: #222;

  .schedule-title {
    color: white;
    font-weight: bold;
    font-size: 12px;
  }
}
</style>
